<template>
  <main>
    <van-cell-group class="mt-3 login">
      <van-field
        v-model="account"
        type="tel"
        clearable
        label="手机号"
        placeholder="请输入手机号">
        <span
          slot="label"
          class="label text-muted">
          <font-awesome-icon
            icon="mobile-alt"
            fixed-width />
        </span>
      </van-field>
      <van-field
        v-model="password"
        type="password"
        label="密码"
        placeholder="请输入密码">
        <span
          slot="label"
          class="label text-muted">
          <font-awesome-icon
            icon="lock"
            fixed-width />
        </span>
      </van-field>
    </van-cell-group>
    <div class="p-3">
      <van-row class="pb-2">
        <van-col span="24">
          <van-button
            type="primary"
            size="large"
            @click="handleLogin">登录</van-button>
        </van-col>
      </van-row>
      <van-row class="pb-2">
        <van-col
          span="12"
          class="text-left">
          <router-link :to="{name: 'register'}">欢迎注册</router-link>
        </van-col>
        <van-col
          span="12"
          class="text-right">
          <router-link :to="{name: 'reset-password'}">忘记密码</router-link>
        </van-col>
      </van-row>
    </div>
  </main>
</template>

<script>
import JSEncrypt from 'jsencrypt';
import { hospitalId, rsaPublicKey } from '@/libs/const';

export default {
  name: 'Login',
  data() {
    return {
      account: '',
      password: '',
    };
  },
  methods: {
    async handleLogin() {
      const { account, password } = this;
      const openId = localStorage.getItem('open_id');
      const jsencrypt = new JSEncrypt();
      jsencrypt.setPublicKey(rsaPublicKey);
      const response = await this.$http.post('/patient-api/webapi/weixin/mp/login', {
        account,
        password: jsencrypt.encrypt(password),
        open_id: openId,
        hospital_id: hospitalId,
      });
      localStorage.setItem('accessToken', response.access_token);
      localStorage.setItem('user', JSON.stringify(response.access_token));
      localStorage.setItem('nickName', response.nick_name);
      this.$toast.success('登录成功');
      // if (this.$route.query.redirect) {
      //   this.$router.replace(this.$route.query.redirect);
      // } else {
      //   this.$router.replace({ name: 'home' });
      // }
      this.$router.push({ name: 'home' });
    },
  },
};
</script>

<style scoped>
.login >>> .van-cell__title {
  max-width: 2rem;
}

.label,
.login >>> .van-field__control {
  font-size: 1rem;
}
</style>
